<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
  <div mat-dialog-title class="dialog-header">
    <h3 class="dialog-title">{{ phone.phoneId > 0 ? 'Edit' : 'Add' }} {{ phone.phoneTypeId }}</h3>
    <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
  </div>

  <form [formGroup]="form" (ngSubmit)="onCreate()">
    <mat-dialog-content>
      @switch (phone.phoneTypeId) {
        @case (phoneTypes.Softphone) {
          @for (sipUser of sipUserArray.controls; track sipUser; let i = $index) {
            <ng-container formArrayName="sipUserArray">
              <ng-container [formGroupName]="i">
                <mat-form-field>
                  <mat-label>SIP Username</mat-label>
                  <input
                    matInput
                    autocomplete="off"
                    type="text"
                    formControlName="sipUsername"
                    required
                    id="12a68305-3ad8-473b-b05e-8478aeafe15e"
                    />
                    @if (sipUserArray.controls[i].hasError('required', 'sipUsername')) {
                      <mat-error
                        >Sip Username is required</mat-error
                        >
                    }
                    @if (
                      !sipUserArray.controls[i].hasError('required', 'sipUsername') &&
                      sipUserArray.controls[i].hasError('noContent', 'sipUsername')
                      ) {
                      <mat-error
                        >Sip Username must contain characters</mat-error
                        >
                      }
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>SIP Password</mat-label>
                      <input
                        matInput
                        autocomplete="off"
                        [type]="showPassword ? 'text' : 'password'"
                        formControlName="sipPassword"
                        required
                        id="a27dd858-a920-4925-932e-8f9a95b2c9c9"
                        />
                        @if (
                          sipUserArray.controls[i].hasError('minlength', 'sipPassword') ||
                          sipUserArray.controls[i].hasError('specialcharacters', 'sipPassword') ||
                          sipUserArray.controls[i].hasError('uppercasecharacters', 'sipPassword') ||
                          sipUserArray.controls[i].hasError('numericcharacters', 'sipPassword')
                          ) {
                          <mat-error
                            >
                            Password must be at least 8 characters and contain an uppercase character, a numeric
                            character, and a special character
                          </mat-error>
                        }
                      </mat-form-field>
                      <mat-checkbox (change)="showPassword = !showPassword">show password</mat-checkbox>
                    </ng-container>
                  </ng-container>
                }
              }
              @case (phoneTypes.Hardphone) {
                <ndt-add-hardphone-view
                  formArrayName="hardphoneArray"
                  [accountId]="accountId"
                  [deviceId]="deviceId"
                ></ndt-add-hardphone-view>
              }
              @case (phoneTypes.Handset) {
                <ng-container formArrayName="handsetArray">
                  @for (handset of handsetArray.controls; track handset; let i = $index) {
                    <ng-container [formGroupName]="i">
                      <mat-form-field>
                        <mat-label>IPEI</mat-label>
                        <input
                          matInput
                          autocomplete="off"
                          type="text"
                          formControlName="handsetIpei"
                          required
                          id="e7a0d82c-d9b5-49e8-af51-322247e3f934"
                          />
                          @if (handset?.get('handsetIpei')?.hasError('required')) {
                            <mat-error>
                              IPEI is required.
                            </mat-error>
                          }
                          @if (handset?.get('handsetIpei')?.hasError('pattern')) {
                            <mat-error
                              >Only alphanumeric characters and colons are allowed.</mat-error
                              >
                          }
                          @if (handset?.get('handsetIpei')?.hasError('maxlength')) {
                            <mat-error
                              >Name has a max length of 10 characters.</mat-error
                              >
                            }
                          </mat-form-field>
                          <ndt-device-chip-input
                            [accountId]="accountId"
                            [formArray]="handset.get('baseStationHandsets')"
                            [deviceTypesToInclude]="[DeviceTypes.RoveB2, DeviceTypes.RoveB4]"
                            [required]="true"
                            >
                          </ndt-device-chip-input>
                        </ng-container>
                      }
                    </ng-container>
                  }
                }
                @if (this.isSystemUser && this.phone?.sipUserMetaData?.length > 0) {
                  <lcs-responsive-table [columns]="columns">
                    <table lcs-table [dataSource]="this.phone.sipUserMetaData">
                      <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
                      <tr lcs-header-row *lcsResponsiveRowDef></tr>
                      <ng-container lcsColumnDef="internalip" width=".5">
                        <th lcs-header-cell *lcsHeaderCellDef id="internal-ip-column-header">Internal IP</th>
                        <td lcs-cell *lcsCellDef="let sipUser"> {{ sipUser?.internalIp }}</td>
                      </ng-container>
                      <ng-container lcsColumnDef="externalip" width=".5">
                        <th lcs-header-cell *lcsHeaderCellDef id="external-ip-column-header">External IP</th>
                        <td lcs-cell *lcsCellDef="let sipUser"> {{ sipUser?.externalIp }}</td>
                      </ng-container>
                      <ng-container lcsColumnDef="useragent" width="1.5">
                        <th lcs-header-cell *lcsHeaderCellDef id="user-agent-column-header">User Agent</th>
                        <td lcs-cell *lcsCellDef="let sipUser"> {{ sipUser?.userAgent }}</td>
                      </ng-container>
                    </table></lcs-responsive-table
                    >
                  }
                </mat-dialog-content>
                <mat-dialog-actions>
                  <button type="submit" title="Create" mat-raised-button id="4f7ba8f5-e6f0-4809-9428-a136bd8187c5">Save</button>
                </mat-dialog-actions>
              </form>
            </lcs-loading-overlay>
